import { render, staticRenderFns } from "./RepairRegistrationEdit.vue?vue&type=template&id=b5309c72&scoped=true"
import script from "./RepairRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./RepairRegistrationEdit.vue?vue&type=script&lang=js"
import style0 from "./RepairRegistrationEdit.vue?vue&type=style&index=0&id=b5309c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5309c72",
  null
  
)

export default component.exports